import { Diagnostic } from "@ionic-native/diagnostic";
import { isCapacitorPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";
import { ShiftWindow } from "@src/appV2/Shifts/Shift/types";
import { UrgentShift } from "@src/appV2/Shifts/UrgentShifts/api/useUrgentShifts";
import { orderBy } from "lodash";

export const requestFullLocationAccess = async () => {
  if (!isCapacitorPlatform()) {
    return;
  }
  await requestLocationAccess();
  Diagnostic.switchToSettings();
};

export const requestLocationAccess = async () => {
  const locationStatus = await Diagnostic.getLocationAuthorizationStatus();

  if (locationStatus !== Diagnostic.permissionStatus.NOT_REQUESTED) {
    return;
  }

  await Diagnostic.requestLocationAuthorization();
};

export const sortUrgentShifts = (
  shifts: UrgentShift[],
  options: { searchParams: URLSearchParams }
): UrgentShift[] => {
  const { searchParams } = options;
  const shiftStart = searchParams.get("shiftStart");
  // not opened from notification
  if (!shiftStart) {
    return orderBy(shifts, [(shift) => (shift.window === ShiftWindow.A_TEAM ? 0 : 1)], ["asc"]);
  }

  // opened from notification
  const sortIdentities = [
    (shift: UrgentShift) => shift.start === shiftStart,
    (shift: UrgentShift) => shift.originalAmount ?? 0,
  ];
  const sortOrders: Array<"asc" | "desc"> = ["desc", "desc"];
  sortIdentities.splice(1, 0, (shift: UrgentShift) =>
    shift.window === ShiftWindow.A_TEAM ? 0 : 1
  );
  sortOrders.splice(1, 0, "asc");

  return orderBy(shifts, sortIdentities, sortOrders);
};
